// extracted by mini-css-extract-plugin
module.exports = {"input":"RightPanel_input__o7yQ6"};